import {isPlatformBrowser, PlatformLocation, isPlatformServer} from '@angular/common';
import { Injectable, PLATFORM_ID, Inject } from '@angular/core';

declare const process: any;

export const getHost = function(platformId, platformLocation: PlatformLocation) {
  if (isPlatformBrowser(platformId)) {
    let toReturn = platformLocation.getBaseHrefFromDOM() || '';

    if (toReturn.endsWith('/')) {
      toReturn = toReturn.substr(0, toReturn.length - 1);
    }
    return toReturn;
  } else {
    // Only called and accessible on the server side.
    return process.env.HOST_URL || '';
  }
};

export const getEnvironmentVariable = (platformId: string, variableName: string): string => {

  if (isPlatformServer(platformId)) {
    return process.env[variableName];
  }
};

/**
 * Exists as a workaround to be able to Inject the PLATFORM_ID into factory methods
 */
@Injectable()
export class PlatformIdHolder {
  constructor(@Inject(PLATFORM_ID) public platformId: string) {}
}
